app.UserProfile = (
    function () {
        var userProfile = {
            Init: function () {
                //initialize the map when the edit card is shown.
                $(document).on("component-bind-edit-mode-complete-ApplicantUserDetails", function () {
                    app.ApplicantRegistration.CesaMapInit();
                    app.UserProfile.DistrictCheck();
                });
                //initialize the district email validation
                app.UserProfile.DistrictEmailValidationInit();

                $(document).on("component-bind-edit-mode-complete-RecoverySettings", function () {
                    app.UserProfile.AccountRecoverySettingsInit();
                });
            },
            DistrictCheck: function () {
                var districtEmailValue = $("[name='DistrictEmail']").val();
                var districtIdValue = $("[name='DistrictId']").val();
                if (districtEmailValue && !districtIdValue) {
                    app.UserProfile.CheckForDistrictByEmail();
                }
                if ($("[data-role='currently-work-for-district']").is(":checked")) {
                    $("[name='DistrictEmail']").attr("disabled", false);
                    $('#district-email-alert').removeAttr("hidden").focus();
                }
                else {
                    $("[name='DistrictEmail']").val(null);
                    $('#district-email-alert').attr("hidden", true);
                }
            },
            DistrictEmailValidationInit: function () {
                $(document).on("change", "[data-role='currently-work-for-district']", function () {
                    if (this.checked) {
                        $("[name='DistrictEmail']").attr("disabled", false);
                        $('#district-email-alert').removeAttr("hidden").focus();
                    } else {
                        var districtContainer = $("#CurrentDistrict");
                        $("[name='DistrictEmail']").attr("disabled", true);
                        $("[name='DistrictEmail']").val(null);
                        $('[data-role="validate-district-success"]').html("");
                        $('#district-email-alert').attr("hidden", true);
                        //clear the district fields if they uncheck the checkbox
                        districtContainer.find("[data-role='validate-district-email']").val("");
                        districtContainer.find('[data-role="district-id"]').val("");
                    }
                });
                $(document).on("keyup", "[data-role='validate-district-email']", function () {
                    var email = $(this).val().trim(); // Trim to remove accidental spaces
                    var atIndex = email.indexOf("@");
                    var shouldSearch = atIndex > 0 && atIndex < email.length - 1;
                    if (shouldSearch) {
                        app.UserProfile.CheckForDistrictByEmail();
                    }
                    else {
                        $('[data-role="validate-district-success"]').html("");
                        $('[data-role="district-id"]').val(null);
                    }
                });
                $(document).on("keydown", function (e) {
                    if (e.key === "Escape") {
                        $("#district-email-alert").attr("hidden", true);
                        $("[name='DistrictEmail']").val("").focus().removeAttr("aria-invalid");
                        $('[data-role="validate-district-success"]').html("");
                        $('[data-role="district-id"]').val(null);

                        // Reset the district dropdown if present
                        if ($("#SelectedDistrictId").length) {
                            $("#SelectedDistrictId").val("").change();
                        }
                    }
                });
            },
            CheckForDistrictByEmail: function () {
                var districtContainer = $("#CurrentDistrict");

                // Show loading and clear previous district fields
                $("#spinneroo", districtContainer).removeAttr("hidden");
                $('[data-role="district-id"]', districtContainer).val("");
                $('[data-role="validate-district-success"]', districtContainer).html("");

                var emailTextbox = $("[data-role='validate-district-email']");
                var emailValue = emailTextbox.val().trim(); // Ensure clean input

                $.post(emailTextbox.data("url"), { email: emailValue })
                    .done(function (data) {
                        if (data.IsSuccess) {

                            // Ensure email format validation
                            if (emailValue.includes("@") && emailValue.split("@")[1].includes(".")) {
                                emailTextbox.removeAttr("aria-invalid").toggleFieldIsValid(true);
                            } else {
                                var invalidMessage = "Invalid email format. Please enter a valid email.";

                                // Mark input as invalid
                                emailTextbox.attr({
                                    "aria-invalid": "true",
                                    "data-val-fieldisvalid": invalidMessage
                                }).toggleFieldIsValid(false);

                                return;
                            }

                            if (data.HasMultipleOptions) {
                                // Ensure only one dropdown is present
                                var districtDropdown = $("#SelectedDistrictId");
                                if (districtDropdown.length) {
                                    districtDropdown.remove();
                                }

                                // Append new dropdown if returned from backend
                                if (data.Message.includes('<select')) {
                                    $('[data-role="validate-district-success"]', districtContainer)
                                        .html(data.Message);
                                }

                                // Ensure dropdown is properly initialized AFTER being injected
                                setTimeout(function () {
                                    var newDropdown = $("#SelectedDistrictId");

                                    if (newDropdown.length) {
                                        // Bind change event only once
                                        newDropdown.off("change").on("change", function () {
                                            var selectedDistrictId = $(this).val();
                                            var selectedDistrictText = $(this).find("option:selected").text().trim();

                                            // Update hidden field for District ID
                                            $('[data-role="district-id"]', districtContainer).val(selectedDistrictId);

                                            // Update visible success message
                                            $('[data-role="validate-district-success"]', districtContainer)
                                                .html("Selected District: " + selectedDistrictText)
                                                .attr("role", "status"); // Announce for screen readers
                                        });

                                        // If a selection already exists, apply it immediately
                                        var initialSelectedId = newDropdown.val();
                                        if (initialSelectedId) {
                                            $('[data-role="district-id"]', districtContainer).val(initialSelectedId);
                                            $('[data-role="validate-district-success"]', districtContainer)
                                                .html("Selected District: " + newDropdown.find("option:selected").text().trim())
                                                .attr("role", "status");
                                        }
                                    }
                                }, 50);
                            } else {
                                if (data.DistrictId === null || data.DistrictId === "" || data.DistrictId === " ") {
                                    var errorMsgContainer = $('[data-role="validate-district-success"]', districtContainer);
                                    errorMsgContainer.html("").attr("role", "alert"); // Clear first to force screen reader update
                                    setTimeout(() => {
                                        errorMsgContainer.html(data.Message);
                                    }, 50);
                                    $('[data-role="district-id"]', districtContainer).val(data.DistrictId);
                                }
                                else {
                                    // If there's only one district, set it immediately
                                    $('[data-role="district-id"]', districtContainer).val(data.DistrictId);
                                    $('[data-role="validate-district-success"]', districtContainer)
                                        .html("Selected District: " + data.Message)
                                        .attr("role", "status");
                                }
                            }

                            $('[data-role="multiple-district-bool"]', districtContainer).val(data.HasMultipleOptions);
                        } else {
                            // Handle failure scenario (no matching district found)
                            emailTextbox.attr("aria-invalid", "true")
                                .attr("data-val-fieldisvalid", data.Message)
                                .toggleFieldIsValid(false);

                            var errorMsgContainer = $('[data-role="validate-district-success"]', districtContainer);
                            errorMsgContainer.html("").attr("role", "alert"); // Clear first to force screen reader update
                            setTimeout(() => {
                                errorMsgContainer.html(data.Message);
                            }, 50);
                        }
                    })
                    .fail(function () {
                        toastr.error("There was an error looking up your district. Please try entering your district email again.");
                        emailTextbox.attr("aria-invalid", "true").toggleFieldIsValid(false);
                    })
                    .always(function () {
                        // Hide loading animation
                        $("#spinneroo", districtContainer).attr("hidden", true);

                        // Reinitialize validation
                        var form = emailTextbox.closest('form')
                            .removeData("validator") /* Reset jQuery validation */
                            .removeData("unobtrusiveValidation");  /* Reset unobtrusive validation */

                        $.validator.unobtrusive.parse(form);
                    });
            },
            //Change Password Page
            ChangePassword: function () {
                $("#formSubmitButton").on("click", function () {
                    $("#confirmModal").modal("hide");
                    $("#changeForm").submit();
                });
            },
            //Change Email Page
            ChangeEmail: function () {
                $("#formSubmitButton").on("click", function () {
                    $("#confirmModal").modal("hide");
                    $("#changeForm").submit();
                });
            },
            AccountRecoverySettingsInit: function () {
                $(document).on("click", '[data-role="security-question-container"] button:not(.input-group-text)', function () {
                    //show textbox to enter new answer
                    $(this).closest('[data-role="security-question-container"]').find('input[type="password"]').show();
                    $(this).closest('[data-role="security-question-container"]').find('[data-role="password-eye-prepend"]').show();
                    $(this).hide();
                });

                $(document).on("change", '[data-role="security-question-container"] select', function () {
                    //show textbox to enter new answer
                    $(this).closest('[data-role="security-question-container"]').find('input[type="password"]').show();
                    $(this).closest('[data-role="security-question-container"]').find("button").hide();
                    //Adding this line becuae showPassword button is disapearing with current logic, but when I shoed the button there was
                    //a whole other button "Edit Answer". 
                    $(this).closest('[data-role="security-question-container"]').find('[data-click="showPassword"]').show();
                    $(this).closest('[data-role="security-question-container"]').find('[data-role="password-eye-prepend"]').show();
                });

                $(document).on("change", "[data-original-email]", function () {
                    //show confirm textbox if different than original
                    if ($(this).data("original-email") != $(this).val()) {
                        //show confirm
                        $(this).closest("form").find("[data-confirm-email]").show();
                    }
                    else {
                        //hide confirm
                        $(this).closest("form").find("[data-confirm-email]").hide();
                        $(this).closest("form").find("[data-confirm-email] input").val("");
                    }
                });
            }
        };

        return userProfile;
    }()
);